import React from "react";
import { Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface ChipProps {
  color?: string;
  fullWidth?: boolean;
  label: string;
  onClick?: () => void;
  selected?: boolean;
  size?: "small" | "medium"
}

export default function Chip(props: ChipProps): React.JSX.Element {
  const theme = useTheme();

  const color = props.color || theme.palette.grey[300];
  const cursor = props.selected !== undefined ? "pointer" : "";
  let textColor = theme.palette.getContrastText(color);
  
  let hoveredBackgroundColor = "";
  let hoveredFilter = "";
  if (props.selected === true) {
    hoveredBackgroundColor = color;
    hoveredFilter = "brightness(80%)";
  } else if (props.selected === false) {
    hoveredBackgroundColor = theme.palette.action.disabled
    hoveredFilter = "";
  }

  const sx: SxProps = {
    backgroundColor: color,
    borderRadius: 100,
    cursor,
    paddingTop: props.size === "medium" ? 1 : 0.5,
    paddingRight: 1,
    paddingBottom: props.size === "medium" ? 1 : 0.5,
    paddingLeft: 1,
    width: props.fullWidth ? "100%" : "fit-content",
    "&:hover": {
      backgroundColor: hoveredBackgroundColor,
      filter: hoveredFilter
    }
  };

  return (
    <Tooltip followCursor title={props.label}>
      <Stack
        direction="row"
        onClick={() => props.onClick?.()}
        sx={[{
          alignItems: "center",
          alignSelf: "center",
          gap: 1,
          height: "max-content",
          maxWidth: props.fullWidth ? "unset" : 128,
          whiteSpace: "nowrap"
        }, ...(Array.isArray(sx) ? sx : [sx])]}>
        {props.selected !== undefined &&
          <>
            {props.selected &&
              <CheckCircleIcon />
              ||
              <RadioButtonUncheckedIcon />
            }
          </>
        }
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: textColor
          }}>{props.label}</Typography>
      </Stack>
    </Tooltip>
  );
}